import Vue from 'vue'
import List from '@/views/List.vue'
import Filter from '@/views/Filter.vue'
import router from './router'
import store from './store'
import labelPlugin from './plugins/labelPlugin'
import settingsPlugin from './plugins/settingsPlugin'
import tooltipLabels from './plugins/tooltiplabels'
import './css/variables.css'

Vue.config.productionTip = false
Vue.use(labelPlugin)
Vue.use(settingsPlugin)
Vue.use(tooltipLabels)

if (document.querySelector('#unit-filterbox')) {
  new Vue({
    store,
    render: (h) => h(Filter),
  }).$mount('#unit-filterbox')
}

if (document.querySelector('#unit-result-list')) {
  new Vue({
    store,
    router,
    render: (h) => h(List),
  }).$mount('#unit-result-list')
}
